function d() {
  window.nostojs = window.nostojs ?? function(t) {
    (window.nostojs.q = window.nostojs.q ?? []).push(t);
  };
}
function l() {
  return typeof window.nosto < "u";
}
function f() {
  return window.nosto;
}
const u = {
  production: "https://connect.nosto.com/",
  staging: "https://connect.staging.nosto.com/",
  local: "https://connect.nosto.com/"
};
function a(t) {
  return u[t ?? "production"];
}
function p({ merchantId: t, env: o, options: r, scriptLoader: e }) {
  const c = new URL(`/include/${t}`, a(o));
  return (e ?? w)(c.toString(), r);
}
function w(t, o) {
  return new Promise((e, c) => {
    const n = document.createElement("script");
    n.src = t, n.async = !0, n.type = "text/javascript", n.onload = () => e(), n.onerror = () => c(), Object.entries((o == null ? void 0 : o.attributes) ?? {}).forEach(([s, i]) => n.setAttribute(s, i)), (o == null ? void 0 : o.position) === "head" ? document.head.appendChild(n) : document.body.appendChild(n);
  });
}
async function m(t) {
  return window.nostojs(t);
}
d();
export {
  f as getNostoWindow,
  p as init,
  d as initNostoStub,
  l as isNostoLoaded,
  m as nostojs
};
